import { CalendarProps } from "@amzn/awsui-components-react";

export const calendarI18nStrings: CalendarProps.I18nStrings = {
    currentMonthAriaLabel: "Current month",
    nextMonthAriaLabel: "Next month",
    nextYearAriaLabel: "Next year",
    previousMonthAriaLabel: "Previous month",
    previousYearAriaLabel: "Previous year",
    todayAriaLabel: "Today",
};